// extracted by mini-css-extract-plugin
var _1 = "ConfirmationPage_confirmationPageContainer__ML+HP";
var _2 = "ConfirmationPage_headerImage__fSBSl";
var _3 = "768px";
var _4 = "ConfirmationPage_message__IGq+7";
var _5 = "'../../../shared.module.css'";
var _6 = "ConfirmationPage_title__MXFUY";
export { _1 as "confirmationPageContainer", _2 as "headerImage", _3 as "md", _4 as "message", _5 as "shared", _6 as "title" }
